import React, { useState, useEffect } from "react";
import Viewprofile from "./Viewprofile";
import AddressBook from "./AddressBook";
import Myorder from "./Myorder";
import Logout from "./Logout";
import Prescription from "./Prescription";
import MyPayment from "./MyPayment";
import NeedHelp from "./NeedHelp";
import { useLocation, useNavigate } from "react-router-dom"; // Import useNavigate
import LoyaltyProgram from "./LoyaltyProgram";
import { useDispatch } from "react-redux";
import { changeRouter } from "../../features/orders/ordersSlice";

const ProfilePage = () => {
  const location = useLocation();
  const navigate = useNavigate(); // Use useNavigate hook
  const [activeTab, setActiveTab] = useState("manage-profiles");
  const dispatch = useDispatch();
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tabParam = searchParams.get("tab");
    if (tabParam) {
      setActiveTab(tabParam);
      dispatch(changeRouter(tabParam));
    }
  }, [location]);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    dispatch(changeRouter(tabId));
    navigate(`?tab=${tabId}`, { replace: true }); // Use navigate here
  };

  return (
    <div className="container-fluid clear my-order-profile">
      <div className="row mt-2">
        <div className="col-lg-4 col-sm-12 col-md-12 main-profile">
          <ul className="nav flex-column" role="tablist">
            <li className="nav-item">
              <a
                className={`nav-link ${
                  activeTab === "manage-profiles" ? "active" : ""
                }`}
                id="manage-profiles-tab"
                data-bs-toggle="pill"
                href="#manage-profiles"
                role="tab"
                aria-controls="manage-profiles"
                aria-selected={activeTab === "manage-profiles"}
                onClick={() => handleTabClick("manage-profiles")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={25}
                  height={25}
                  viewBox="0 0 27 20"
                  fill="none"
                >
                  <path
                    d="M16.2069 10.3448C15.1839 10.3448 14.1839 10.0415 13.3333 9.47312C12.4827 8.90477 11.8197 8.09695 11.4282 7.15181C11.0367 6.20668 10.9343 5.16668 11.1339 4.16333C11.3334 3.15998 11.8261 2.23834 12.5494 1.51497C13.2728 0.791592 14.1945 0.298968 15.1978 0.0993888C16.2012 -0.10019 17.2412 0.00224113 18.1863 0.393729C19.1314 0.785217 19.9392 1.44818 20.5076 2.29878C21.076 3.14938 21.3793 4.14941 21.3793 5.17241C21.3793 6.54422 20.8344 7.85985 19.8643 8.82986C18.8943 9.79988 17.5787 10.3448 16.2069 10.3448ZM16.2069 2.06897C15.5931 2.06897 14.9931 2.25098 14.4827 2.59199C13.9724 2.933 13.5746 3.4177 13.3397 3.98478C13.1048 4.55186 13.0433 5.17586 13.1631 5.77787C13.2828 6.37988 13.5784 6.93286 14.0124 7.36688C14.4465 7.80091 14.9994 8.09648 15.6014 8.21623C16.2035 8.33598 16.8274 8.27452 17.3945 8.03963C17.9616 7.80473 18.4463 7.40696 18.7873 6.8966C19.1283 6.38624 19.3103 5.78622 19.3103 5.17241C19.3103 4.34933 18.9834 3.55996 18.4014 2.97795C17.8194 2.39594 17.03 2.06897 16.2069 2.06897ZM25.8621 20C25.5888 19.9964 25.3278 19.8863 25.1345 19.6931C24.9413 19.4998 24.8312 19.2388 24.8276 18.9655C24.8276 16.2759 23.3655 14.4828 16.2069 14.4828C9.04827 14.4828 7.58621 16.2759 7.58621 18.9655C7.58621 19.2399 7.47722 19.503 7.28321 19.697C7.08921 19.891 6.82609 20 6.55172 20C6.27736 20 6.01424 19.891 5.82023 19.697C5.62623 19.503 5.51724 19.2399 5.51724 18.9655C5.51724 12.4138 13.0069 12.4138 16.2069 12.4138C19.4069 12.4138 26.8965 12.4138 26.8965 18.9655C26.893 19.2388 26.7828 19.4998 26.5896 19.6931C26.3964 19.8863 26.1353 19.9964 25.8621 20ZM8.37241 11.4621H7.93103C6.83359 11.356 5.82323 10.8183 5.12223 9.96725C4.42123 9.11623 4.08702 8.02159 4.1931 6.92414C4.29919 5.82669 4.83689 4.81634 5.68792 4.11534C6.53894 3.41434 7.63359 3.08012 8.73103 3.18621C8.87175 3.19226 9.00975 3.22698 9.13657 3.28824C9.2634 3.3495 9.37638 3.43602 9.46859 3.54249C9.5608 3.64895 9.63029 3.77313 9.67282 3.9074C9.71534 4.04167 9.73 4.18322 9.71589 4.32336C9.70179 4.46349 9.65921 4.59928 9.59077 4.72238C9.52234 4.84548 9.42948 4.95331 9.3179 5.03926C9.20632 5.12522 9.07837 5.18748 8.94188 5.22223C8.80539 5.25699 8.66324 5.2635 8.52414 5.24138C8.25488 5.21453 7.98298 5.24222 7.72467 5.3228C7.46635 5.40337 7.22693 5.53518 7.02069 5.71035C6.81121 5.87932 6.63747 6.0883 6.50959 6.32511C6.38171 6.56192 6.30226 6.82182 6.27586 7.08966C6.24734 7.36085 6.27307 7.63501 6.35156 7.89616C6.43005 8.15731 6.55973 8.40023 6.73303 8.61076C6.90634 8.82129 7.11981 8.99524 7.36101 9.12245C7.60221 9.24966 7.86631 9.3276 8.13793 9.35172C8.58695 9.39013 9.03647 9.2838 9.42069 9.04828C9.65481 8.90378 9.93674 8.8582 10.2045 8.92158C10.4722 8.98495 10.7038 9.15209 10.8483 9.38621C10.9928 9.62033 11.0383 9.90226 10.975 10.17C10.9116 10.4377 10.7445 10.6693 10.5103 10.8138C9.87062 11.2218 9.13101 11.4461 8.37241 11.4621ZM1.03448 18.9655C0.761232 18.9619 0.500178 18.8518 0.306943 18.6586C0.113709 18.4653 0.00357236 18.2043 0 17.931C0 14.2069 0.993103 11.7241 5.86207 11.7241C6.13643 11.7241 6.39955 11.8331 6.59356 12.0271C6.78756 12.2211 6.89655 12.4843 6.89655 12.7586C6.89655 13.033 6.78756 13.2961 6.59356 13.4901C6.39955 13.6841 6.13643 13.7931 5.86207 13.7931C2.62069 13.7931 2.06897 14.8276 2.06897 17.931C2.06539 18.2043 1.95526 18.4653 1.76202 18.6586C1.56879 18.8518 1.30773 18.9619 1.03448 18.9655Z"
                    fill="#30B09B"
                  />
                </svg>
                <span>Manage Profiles</span>
              </a>
            </li>

            <li className="nav-item">
              <a
                className={`nav-link ${
                  activeTab === "loyalty-program" ? "active" : ""
                }`}
                id="my-loyalty-program"
                data-bs-toggle="pill"
                href="#my-loyalty"
                role="tab"
                aria-controls="my-loyalty"
                aria-selected={activeTab === "loyalty-program"}
                onClick={() => handleTabClick("loyalty-program")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={25}
                  height={25}
                  viewBox="0 0 19 22"
                  fill="none"
                >
                  <path
                    d="M15.1176 1H3.35294C2.05345 1 1 2.05345 1 3.35294V18.6471C1 19.9466 2.05345 21 3.35294 21H15.1176C16.4171 21 17.4706 19.9466 17.4706 18.6471V3.35294C17.4706 2.05345 16.4171 1 15.1176 1Z"
                    stroke="#30B09B"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M5.70605 6.88235H12.7649M5.70605 11.5882H12.7649M5.70605 16.2941H10.4119"
                    stroke="#30B09B"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
                <span>Loyalty Program</span>
              </a>
            </li>

            <li className="nav-item">
              <a
                className={`nav-link ${
                  activeTab === "my-orders" ? "active" : ""
                }`}
                id="my-orders-tab"
                data-bs-toggle="pill"
                href="#my-orders"
                role="tab"
                aria-controls="my-orders"
                aria-selected={activeTab === "my-orders"}
                onClick={() => handleTabClick("my-orders")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={25}
                  height={25}
                  viewBox="0 0 19 22"
                  fill="none"
                >
                  <path
                    d="M15.1176 1H3.35294C2.05345 1 1 2.05345 1 3.35294V18.6471C1 19.9466 2.05345 21 3.35294 21H15.1176C16.4171 21 17.4706 19.9466 17.4706 18.6471V3.35294C17.4706 2.05345 16.4171 1 15.1176 1Z"
                    stroke="#30B09B"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M5.70605 6.88235H12.7649M5.70605 11.5882H12.7649M5.70605 16.2941H10.4119"
                    stroke="#30B09B"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
                <span>My Orders</span>
              </a>
            </li>

            <li className="nav-item">
              <a
                className={`nav-link ${
                  activeTab === "my-payments" ? "active" : ""
                }`}
                id="my-payments-tab"
                data-bs-toggle="pill"
                href="#my-payments"
                role="tab"
                aria-controls="my-payments"
                aria-selected={activeTab === "my-payments"}
                onClick={() => handleTabClick("my-payments")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={25}
                  height={25}
                  viewBox="0 0 15 22"
                  fill="none"
                >
                  <path
                    d="M1 1H13.9412M1 6.55529H13.9412M10.1671 21L1 12.1106H4.23529C11.4247 12.1106 11.4247 1 4.23529 1"
                    stroke="#30B09B"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span>My Payments</span>
              </a>
            </li>

            <li className="nav-item">
              <a
                className={`nav-link ${
                  activeTab === "address-book" ? "active" : ""
                }`}
                id="address-book-tab"
                data-bs-toggle="pill"
                href="#address-book"
                role="tab"
                aria-controls="address-book"
                aria-selected={activeTab === "address-book"}
                onClick={() => handleTabClick("address-book")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={25}
                  height={25}
                  viewBox="0 0 20 20"
                  fill="none"
                  className="__web-inspector-hide-shortcut__"
                >
                  <path
                    d="M13.05 11.3853C13.6681 10.9117 14.1223 10.2564 14.3488 9.51143C14.5752 8.76643 14.5626 7.96919 14.3125 7.23176C14.0625 6.49433 13.5877 5.85377 12.9549 5.4001C12.3221 4.94643 11.563 4.70245 10.7843 4.70245C10.0057 4.70245 9.24657 4.94643 8.61372 5.4001C7.98088 5.85377 7.50609 6.49433 7.25608 7.23176C7.00607 7.96919 6.9934 8.76643 7.21986 9.51143C7.44632 10.2564 7.90052 10.9117 8.51863 11.3853C7.35883 11.8184 6.34831 12.5764 5.60784 13.5686C5.51424 13.6934 5.47405 13.8503 5.49611 14.0048C5.51817 14.1592 5.60068 14.2986 5.72549 14.3922C5.8503 14.4858 6.00718 14.526 6.16162 14.5039C6.31606 14.4818 6.45541 14.3993 6.54902 14.2745C7.04215 13.617 7.6816 13.0833 8.41671 12.7158C9.15183 12.3482 9.96243 12.1569 10.7843 12.1569C11.6062 12.1569 12.4168 12.3482 13.1519 12.7158C13.887 13.0833 14.5265 13.617 15.0196 14.2745C15.1132 14.3993 15.2526 14.4818 15.407 14.5039C15.5614 14.526 15.7183 14.4858 15.8431 14.3922C15.9679 14.2986 16.0505 14.1592 16.0725 14.0048C16.0946 13.8503 16.0544 13.6934 15.9608 13.5686C15.2203 12.5764 14.2098 11.8184 13.05 11.3853ZM8.23529 8.43137C8.23529 7.92722 8.38479 7.4344 8.66488 7.01521C8.94497 6.59603 9.34307 6.26932 9.80885 6.07639C10.2746 5.88346 10.7871 5.83298 11.2816 5.93133C11.7761 6.02969 12.2303 6.27246 12.5867 6.62894C12.9432 6.98543 13.186 7.43962 13.2844 7.93408C13.3827 8.42854 13.3322 8.94107 13.1393 9.40684C12.9464 9.87261 12.6197 10.2707 12.2005 10.5508C11.7813 10.8309 11.2885 10.9804 10.7843 10.9804C10.1083 10.9804 9.45992 10.7118 8.98188 10.2338C8.50385 9.75577 8.23529 9.10742 8.23529 8.43137ZM17.8431 0H3.72549C3.36147 0 3.01235 0.144608 2.75495 0.40201C2.49755 0.659413 2.35294 1.00853 2.35294 1.37255V3.92157H0.588235C0.432226 3.92157 0.282606 3.98354 0.17229 4.09386C0.0619745 4.20417 0 4.35379 0 4.5098C0 4.66581 0.0619745 4.81543 0.17229 4.92575C0.282606 5.03606 0.432226 5.09804 0.588235 5.09804H2.35294V9.41177H0.588235C0.432226 9.41177 0.282606 9.47374 0.17229 9.58405C0.0619745 9.69437 0 9.84399 0 10C0 10.156 0.0619745 10.3056 0.17229 10.4159C0.282606 10.5263 0.432226 10.5882 0.588235 10.5882H2.35294V14.902H0.588235C0.432226 14.902 0.282606 14.9639 0.17229 15.0743C0.0619745 15.1846 0 15.3342 0 15.4902C0 15.6462 0.0619745 15.7958 0.17229 15.9061C0.282606 16.0165 0.432226 16.0784 0.588235 16.0784H2.35294V18.6275C2.35294 18.9915 2.49755 19.3406 2.75495 19.598C3.01235 19.8554 3.36147 20 3.72549 20H17.8431C18.2072 20 18.5563 19.8554 18.8137 19.598C19.0711 19.3406 19.2157 18.9915 19.2157 18.6275V1.37255C19.2157 1.00853 19.0711 0.659413 18.8137 0.40201C18.5563 0.144608 18.2072 0 17.8431 0ZM18.0392 18.6275C18.0392 18.6795 18.0186 18.7293 17.9818 18.7661C17.945 18.8029 17.8951 18.8235 17.8431 18.8235H3.72549C3.67349 18.8235 3.62361 18.8029 3.58684 18.7661C3.55007 18.7293 3.52941 18.6795 3.52941 18.6275V1.37255C3.52941 1.32055 3.55007 1.27067 3.58684 1.2339C3.62361 1.19713 3.67349 1.17647 3.72549 1.17647H17.8431C17.8951 1.17647 17.945 1.19713 17.9818 1.2339C18.0186 1.27067 18.0392 1.32055 18.0392 1.37255V18.6275Z"
                    fill="#30B09B"
                  />
                </svg>
                <span>Address Book</span>
              </a>
            </li>

            <li className="nav-item">
              <a
                className={`nav-link ${
                  activeTab === "prescription" ? "active" : ""
                }`}
                id="prescription-tab"
                data-bs-toggle="pill"
                href="#prescription"
                role="tab"
                aria-controls="prescription"
                aria-selected={activeTab === "prescription"}
                onClick={() => handleTabClick("prescription")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={25}
                  height={25}
                  viewBox="0 0 20 20"
                  fill="none"
                  className="__web-inspector-hide-shortcut__"
                >
                  <path
                    d="M13.05 11.3853C13.6681 10.9117 14.1223 10.2564 14.3488 9.51143C14.5752 8.76643 14.5626 7.96919 14.3125 7.23176C14.0625 6.49433 13.5877 5.85377 12.9549 5.4001C12.3221 4.94643 11.563 4.70245 10.7843 4.70245C10.0057 4.70245 9.24657 4.94643 8.61372 5.4001C7.98088 5.85377 7.50609 6.49433 7.25608 7.23176C7.00607 7.96919 6.9934 8.76643 7.21986 9.51143C7.44632 10.2564 7.90052 10.9117 8.51863 11.3853C7.35883 11.8184 6.34831 12.5764 5.60784 13.5686C5.51424 13.6934 5.47405 13.8503 5.49611 14.0048C5.51817 14.1592 5.60068 14.2986 5.72549 14.3922C5.8503 14.4858 6.00718 14.526 6.16162 14.5039C6.31606 14.4818 6.45541 14.3993 6.54902 14.2745C7.04215 13.617 7.6816 13.0833 8.41671 12.7158C9.15183 12.3482 9.96243 12.1569 10.7843 12.1569C11.6062 12.1569 12.4168 12.3482 13.1519 12.7158C13.887 13.0833 14.5265 13.617 15.0196 14.2745C15.1132 14.3993 15.2526 14.4818 15.407 14.5039C15.5614 14.526 15.7183 14.4858 15.8431 14.3922C15.9679 14.2986 16.0505 14.1592 16.0725 14.0048C16.0946 13.8503 16.0544 13.6934 15.9608 13.5686C15.2203 12.5764 14.2098 11.8184 13.05 11.3853ZM8.23529 8.43137C8.23529 7.92722 8.38479 7.4344 8.66488 7.01521C8.94497 6.59603 9.34307 6.26932 9.80885 6.07639C10.2746 5.88346 10.7871 5.83298 11.2816 5.93133C11.7761 6.02969 12.2303 6.27246 12.5867 6.62894C12.9432 6.98543 13.186 7.43962 13.2844 7.93408C13.3827 8.42854 13.3322 8.94107 13.1393 9.40684C12.9464 9.87261 12.6197 10.2707 12.2005 10.5508C11.7813 10.8309 11.2885 10.9804 10.7843 10.9804C10.1083 10.9804 9.45992 10.7118 8.98188 10.2338C8.50385 9.75577 8.23529 9.10742 8.23529 8.43137ZM17.8431 0H3.72549C3.36147 0 3.01235 0.144608 2.75495 0.40201C2.49755 0.659413 2.35294 1.00853 2.35294 1.37255V3.92157H0.588235C0.432226 3.92157 0.282606 3.98354 0.17229 4.09386C0.0619745 4.20417 0 4.35379 0 4.5098C0 4.66581 0.0619745 4.81543 0.17229 4.92575C0.282606 5.03606 0.432226 5.09804 0.588235 5.09804H2.35294V9.41177H0.588235C0.432226 9.41177 0.282606 9.47374 0.17229 9.58405C0.0619745 9.69437 0 9.84399 0 10C0 10.156 0.0619745 10.3056 0.17229 10.4159C0.282606 10.5263 0.432226 10.5882 0.588235 10.5882H2.35294V14.902H0.588235C0.432226 14.902 0.282606 14.9639 0.17229 15.0743C0.0619745 15.1846 0 15.3342 0 15.4902C0 15.6462 0.0619745 15.7958 0.17229 15.9061C0.282606 16.0165 0.432226 16.0784 0.588235 16.0784H2.35294V18.6275C2.35294 18.9915 2.49755 19.3406 2.75495 19.598C3.01235 19.8554 3.36147 20 3.72549 20H17.8431C18.2072 20 18.5563 19.8554 18.8137 19.598C19.0711 19.3406 19.2157 18.9915 19.2157 18.6275V1.37255C19.2157 1.00853 19.0711 0.659413 18.8137 0.40201C18.5563 0.144608 18.2072 0 17.8431 0ZM18.0392 18.6275C18.0392 18.6795 18.0186 18.7293 17.9818 18.7661C17.945 18.8029 17.8951 18.8235 17.8431 18.8235H3.72549C3.67349 18.8235 3.62361 18.8029 3.58684 18.7661C3.55007 18.7293 3.52941 18.6795 3.52941 18.6275V1.37255C3.52941 1.32055 3.55007 1.27067 3.58684 1.2339C3.62361 1.19713 3.67349 1.17647 3.72549 1.17647H17.8431C17.8951 1.17647 17.945 1.19713 17.9818 1.2339C18.0186 1.27067 18.0392 1.32055 18.0392 1.37255V18.6275Z"
                    fill="#30B09B"
                  />
                </svg>
                <span>Prescription</span>
              </a>
            </li>

            <li className="nav-item">
              <a
                className={`nav-link ${
                  activeTab === "need-help" ? "active" : ""
                }`}
                id="need-help-tab"
                data-bs-toggle="pill"
                href="#need-help"
                role="tab"
                aria-controls="need-help"
                aria-selected={activeTab === "need-help"}
                onClick={() => handleTabClick("need-help")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={25}
                  height={25}
                  viewBox="0 0 25 25"
                  fill="none"
                >
                  <path
                    d="M12.4998 1.38889C10.3022 1.38889 8.154 2.04055 6.32679 3.26145C4.49957 4.48236 3.07543 6.21768 2.23446 8.24797C1.39349 10.2783 1.17345 12.5123 1.60217 14.6677C2.0309 16.823 3.08913 18.8028 4.64305 20.3567C6.19696 21.9107 8.17677 22.9689 10.3321 23.3976C12.4875 23.8263 14.7215 23.6063 16.7518 22.7653C18.7821 21.9244 20.5174 20.5002 21.7383 18.673C22.9592 16.8458 23.6109 14.6976 23.6109 12.5C23.6109 9.55315 22.4403 6.727 20.3565 4.64326C18.2728 2.55952 15.4466 1.38889 12.4998 1.38889ZM12.4998 22.2222C10.5769 22.2222 8.69722 21.652 7.09841 20.5837C5.4996 19.5154 4.25348 17.997 3.51763 16.2205C2.78177 14.444 2.58924 12.4892 2.96438 10.6033C3.33951 8.71737 4.26546 6.98503 5.62514 5.62536C6.98482 4.26568 8.71715 3.33973 10.6031 2.96459C12.489 2.58946 14.4438 2.78199 16.2203 3.51784C17.9968 4.25369 19.5152 5.49982 20.5835 7.09863C21.6518 8.69744 22.222 10.5771 22.222 12.5C22.222 15.0785 21.1977 17.5514 19.3744 19.3747C17.5512 21.1979 15.0783 22.2222 12.4998 22.2222Z"
                    fill="#30B09B"
                  />
                  <path
                    d="M12.7013 6.19446C11.9487 6.18202 11.2027 6.33548 10.5162 6.64394C9.82966 6.95239 9.2195 7.40827 8.72906 7.97918C8.66092 8.04232 8.60615 8.11849 8.56798 8.20318C8.52981 8.28788 8.50902 8.37936 8.50684 8.47223C8.50679 8.55792 8.52398 8.64273 8.55738 8.72164C8.59078 8.80054 8.63972 8.87192 8.70127 8.93152C8.76282 8.99113 8.83573 9.03775 8.91566 9.0686C8.9956 9.09946 9.08092 9.11392 9.16656 9.11112C9.35001 9.10657 9.52543 9.03492 9.65961 8.90973C10.0308 8.47479 10.4917 8.12542 11.0108 7.88566C11.5299 7.6459 12.0948 7.52144 12.6666 7.52084C14.3054 7.52084 15.3263 8.5764 15.3263 9.8889V9.92362C15.3263 11.4583 14.1041 12.3125 12.1735 12.4583C12.0953 12.4614 12.0187 12.4809 11.9486 12.5155C11.8784 12.5502 11.8164 12.5994 11.7666 12.6597C11.7168 12.72 11.6803 12.7901 11.6594 12.8655C11.6386 12.9409 11.6339 13.0199 11.6457 13.0972C11.6457 13.0972 11.6457 14.7083 11.6457 15.007C11.663 15.1788 11.7437 15.3381 11.8721 15.4537C12.0005 15.5693 12.1674 15.6328 12.3402 15.632H12.4166C12.5884 15.6147 12.7477 15.534 12.8633 15.4056C12.9789 15.2771 13.0424 15.1103 13.0416 14.9375V13.507C15.1249 13.2153 16.8124 12.1181 16.8124 9.84029V9.80557C16.7916 7.72223 15.1666 6.19446 12.7013 6.19446Z"
                    fill="#30B09B"
                  />
                  <path
                    d="M12.3466 19.0625C12.826 19.0625 13.2146 18.6739 13.2146 18.1944C13.2146 17.715 12.826 17.3264 12.3466 17.3264C11.8672 17.3264 11.4785 17.715 11.4785 18.1944C11.4785 18.6739 11.8672 19.0625 12.3466 19.0625Z"
                    fill="#30B09B"
                  />
                </svg>
                <span>Need Help</span>
              </a>
            </li>

            <li className="nav-item">
              <a
                className={`nav-link ${activeTab === "logout" ? "active" : ""}`}
                id="logout-tab"
                data-bs-toggle="pill"
                href="#logout"
                role="tab"
                aria-controls="logout"
                aria-selected={activeTab === "logout"}
                onClick={() => handleTabClick("logout")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={25}
                  height={25}
                  viewBox="0 0 25 25"
                  fill="none"
                  className=""
                >
                  <path
                    d="M4.86155 4.16667H15.9727V10.9722H17.3615V4.16667C17.3615 3.79831 17.2152 3.44504 16.9547 3.18457C16.6943 2.92411 16.341 2.77778 15.9727 2.77778H4.86155C4.49319 2.77778 4.13992 2.92411 3.87945 3.18457C3.61899 3.44504 3.47266 3.79831 3.47266 4.16667V20.8333C3.47266 21.2017 3.61899 21.555 3.87945 21.8154C4.13992 22.0759 4.49319 22.2222 4.86155 22.2222H15.9727C16.341 22.2222 16.6943 22.0759 16.9547 21.8154C17.2152 21.555 17.3615 21.2017 17.3615 20.8333H4.86155V4.16667Z"
                    fill="#30B09B"
                  />
                  <path
                    d="M19.555 12C19.4222 11.8862 19.2513 11.8268 19.0765 11.8335C18.9017 11.8403 18.7359 11.9127 18.6123 12.0364C18.4886 12.1601 18.4161 12.3259 18.4094 12.5007C18.4026 12.6754 18.4621 12.8463 18.5758 12.9792L20.9231 15.2778H10.8536C10.6694 15.2778 10.4928 15.3509 10.3626 15.4812C10.2323 15.6114 10.1592 15.7881 10.1592 15.9722C10.1592 16.1564 10.2323 16.333 10.3626 16.4633C10.4928 16.5935 10.6694 16.6667 10.8536 16.6667H20.9231L18.5758 19.0695C18.5032 19.1317 18.4441 19.2083 18.4024 19.2945C18.3607 19.3806 18.3373 19.4745 18.3336 19.5701C18.3299 19.6657 18.346 19.7611 18.381 19.8502C18.4159 19.9393 18.4688 20.0203 18.5365 20.088C18.6042 20.1556 18.6851 20.2086 18.7742 20.2435C18.8633 20.2784 18.9587 20.2945 19.0544 20.2908C19.15 20.2871 19.2438 20.2637 19.33 20.222C19.4161 20.1804 19.4928 20.1213 19.555 20.0486L23.6106 16.0208L19.555 12Z"
                    fill="#30B09B"
                  />
                </svg>
                <span>Logout</span>
              </a>
            </li>
          </ul>
        </div>
        <div className="col-lg-8 col-sm-12 col-md-12 second-profile">
          <div className="tab-content">
            <div
              className={`tab-pane fade ${
                activeTab === "manage-profiles" ? "show active" : ""
              }`}
              id="manage-profiles"
              role="tabpanel"
              aria-labelledby="manage-profiles-tab"
            >
              <Viewprofile />
            </div>

            <div
              className={`tab-pane fade ${
                activeTab === "loyalty-program" ? "show active" : ""
              }`}
              id="loyalty-program"
              role="tabpanel"
              aria-labelledby="loyalty-program-tab"
            >
              <LoyaltyProgram />
            </div>
            <div
              className={`tab-pane fade ${
                activeTab === "my-orders" ? "show active" : ""
              }`}
              id="my-orders"
              role="tabpanel"
              aria-labelledby="my-orders-tab"
            >
              <Myorder />
            </div>

            {/* Add other tab panes here... */}
            <div
              className={`tab-pane fade ${
                activeTab === "address-book" ? "show active" : ""
              }`}
              id="address-book"
              role="tabpanel"
              aria-labelledby="address-book-tab"
            >
              {/* My Orders content */}

              <AddressBook />
            </div>

            <div
              className={`tab-pane fade ${
                activeTab === "prescription" ? "show active" : ""
              }`}
              id="prescription"
              role="tabpanel"
              aria-labelledby="prescription-tab"
            >
              {/* My Orders content */}

              <Prescription />
            </div>

            <div
              className={`tab-pane fade ${
                activeTab === "my-payments" ? "show active" : ""
              }`}
              id="my-payments"
              role="tabpanel"
              aria-labelledby="my-payments-tab"
            >
              {/* My Orders content */}
              <MyPayment />
            </div>

            <div
              className={`tab-pane fade ${
                activeTab === "need-help" ? "show active" : ""
              }`}
              id="need-help"
              role="tabpanel"
              aria-labelledby="need-help-tab"
            >
              {/* My Orders content */}
              <NeedHelp />
            </div>

            <div
              className={`tab-pane fade ${
                activeTab === "logout" ? "show active" : ""
              }`}
              id="logout"
              role="tabpanel"
              aria-labelledby="logout-tab"
            >
              {activeTab === "logout" && <Logout />}{" "}
              {/* Render Logout component only when logout tab is active */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
